import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="border-t border-border bg-background mt-24">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-2 mb-4">
                        <span className="font-black text-xl tracking-tighter text-primary neon-text">
                            KICK
                        </span>
                        <span className="font-black text-xl tracking-tighter text-white">
                            LOOM
                        </span>
                    </div>
                    <p className="text-sm text-zinc-400 max-w-md leading-relaxed">
                        AI-powered football predictions. Built for sharp bettors who
                        respect data, value, and discipline.
                    </p>
                </div>
                <div>
                    <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">
                        Product
                    </h4>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link to="/" className="text-zinc-300 hover:text-primary transition-snappy">
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link to="/live" className="text-zinc-300 hover:text-primary transition-snappy" data-testid="footer-live-link">
                                Live Scores
                            </Link>
                        </li>
                        <li>
                            <Link to="/results" className="text-zinc-300 hover:text-primary transition-snappy" data-testid="footer-results-link">
                                Results
                            </Link>
                        </li>
                        <li>
                            <Link to="/login" className="text-zinc-300 hover:text-primary transition-snappy">
                                Login
                            </Link>
                        </li>
                        <li>
                            <Link to="/register" className="text-zinc-300 hover:text-primary transition-snappy">
                                Register
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">
                        Legal
                    </h4>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link
                                to="/terms"
                                className="text-zinc-300 hover:text-primary transition-snappy"
                                data-testid="footer-terms-link"
                            >
                                Terms of Service
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/privacy"
                                className="text-zinc-300 hover:text-primary transition-snappy"
                                data-testid="footer-privacy-link"
                            >
                                Privacy Policy
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/responsible-play"
                                className="text-zinc-300 hover:text-primary transition-snappy"
                                data-testid="footer-responsible-link"
                            >
                                Responsible Play
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-border">
                <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs font-mono uppercase tracking-widest text-zinc-500">
                    <span>© {new Date().getFullYear()} KickLoom · All rights reserved</span>
                    <span>Predictions are statistical insights — not financial advice.</span>
                </div>
            </div>
        </footer>
    );
}
